export default __webpack_public_path__ + "static/media/5.e30f316a.jpg";